import React from 'react';
const AiraBotTitle = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <g
      filter="url(#filter0_d_257_92866)"
      transform="translate(-4)"
      style={{ mixBlendMode: 'normal' }}
    >
      <path
        fill="#04265e"
        d="M4 16C4 7.163 11.163 0 20 0s16 7.163 16 16v12a4 4 0 01-4 4H20c-8.837 0-16-7.163-16-16z"
      />
      <g
        mask="url(#mask0_257_92866)"
        transform="matrix(.86136 0 0 .74916 3.558 1.002)"
      >
        <g fillRule="evenodd" clipRule="evenodd">
          <path
            fill="#9fbfd9"
            d="M31.299 18.782l-1.955.242c-.274.034-.516-.15-.539-.41l-.235-2.657c-.024-.261.18-.5.454-.534l1.955-.242c.275-.034.516.15.539.41l.235 2.657c.024.26-.18.5-.454.534z"
          />
          <path
            fill="#ffe06d"
            d="M32.517 11.006a2.99 2.99 0 01-.77 2.342.969.969 0 00-.243.756l.128 1.151a.954.954 0 01-.846 1.062l-1.899.195a.974.974 0 01-1.06-.867l-.127-1.15a.986.986 0 00-.403-.69 3.043 3.043 0 01-1.266-2.133c-.188-1.7 1.111-3.226 2.902-3.41 1.79-.183 3.396 1.045 3.584 2.744z"
          />
          <path
            fill="#ffb455"
            d="M28.902 7.954a3.727 3.727 0 00-2.397 1.235c-.61.695-.897 1.562-.808 2.441.047.462.193.897.435 1.294.234.381.544.708.922.972a.63.63 0 01.27.455l.113 1.116a1.232 1.232 0 001.375 1.089l1.894-.213a1.267 1.267 0 001.127-1.37l-.113-1.117a.647.647 0 01.173-.505c.317-.342.555-.73.708-1.156.158-.441.214-.899.168-1.36-.09-.88-.543-1.664-1.278-2.208a3.644 3.644 0 00-2.589-.673zm.03.295c1.787-.201 3.37.972 3.537 2.619.086.855-.227 1.67-.797 2.284a.946.946 0 00-.252.738l.113 1.116a.962.962 0 01-.857 1.042l-1.894.213a.935.935 0 01-1.045-.827l-.113-1.116a.923.923 0 00-.393-.665c-.68-.474-1.148-1.201-1.235-2.056-.165-1.648 1.149-3.147 2.936-3.348z"
          />
          <g fill="#779ab6">
            <path d="M31.474 16.734l-2.862.434c-.075.011-.138-.032-.141-.097-.004-.065.053-.127.128-.138l2.862-.434c.075-.011.138.032.141.097.004.065-.053.127-.128.138zM31.834 17.597l-2.862.434c-.075.011-.138-.032-.142-.097-.003-.065.055-.127.129-.138l2.862-.434c.075-.011.138.032.141.097.004.065-.054.127-.128.138zM31.67 17.996l-2.863.434c-.074.011-.137-.032-.141-.097-.004-.065.054-.127.128-.138l2.863-.434c.074-.011.137.032.141.097.004.065-.054.127-.128.138z" />
          </g>
          <path
            fill="#fff088"
            d="M32.204 11.052a2.623 2.623 0 11-5.216.557 2.623 2.623 0 015.216-.557z"
          />
          <path
            fill="#ffffb8"
            d="M29.654 12.384a2.25 2.25 0 01-1.601-.41.105.105 0 01-.014-.153.121.121 0 01.163-.021c.15.112.699.472 1.466.362a2.154 2.154 0 001.306-.712.122.122 0 01.163-.02.105.105 0 01.013.154 2.408 2.408 0 01-1.496.8zM28.759 15.84c-.09.018-.162-.02-.16-.086l.035-1.44c.002-.065.076-.133.167-.152.09-.018.163.02.16.086l-.035 1.44c-.002.065-.076.134-.167.152z"
          />
        </g>
        <path
          fill="#ffb455"
          d="M18.606 6.948l-.828-1.14-1.374-.316 1.141-.828.316-1.374.827 1.141 1.374.316-1.14.828zm3.476-.47l.63-2.748 1.656 2.282 2.748.631L24.834 8.3l-.63 2.747-1.656-2.281-2.748-.631z"
        />
        <g fillRule="evenodd" clipRule="evenodd">
          <path
            fill="#5fbbe8"
            d="M12.31 25.234c.786.425.345 1.319-.67 2.398-1.214 1.29-4.443 2.688-6.322 1.664a2.375 2.375 0 01-.478-.342c-1.752-1.622 5.383-4.043 6.4-3.97.481.035.832.121 1.07.25z"
          />
          <path
            fill="#5faede"
            d="M12.319 25.185c.758.458.338 1.413-.636 2.564-1.162 1.376-4.265 2.858-6.079 1.754 1.883-.163 5.06-.957 6.715-4.318z"
          />
          <path
            fill="#b1eced"
            d="M6.467 27.07c.521-.25 1.421-.582 1.52-.408.1.177-.632.886-1.5 1.255-.592.251-1.356.39-1.429.225-.082-.186.73-.746 1.409-1.072z"
          />
          <path
            fill="#5fbbe8"
            d="M27.278 27.455c.143 3.62-2.225 7.973-6.256 8.133-2.498.1-4.615-1.35-5.897-3.35-.79-1.227-1.264-2.661-1.32-4.072-.146-3.709 3.904-3.693 6.467-3.794 2.81-.112 6.139-.46 6.865 2.136.079.28.127.595.141.947z"
          />
          <path
            fill="#5faede"
            d="M27.277 27.535c.142 3.585-2.21 7.895-6.21 8.054-2.48.098-4.58-1.337-5.853-3.316 2.531 1.07 9.705 3.208 11.922-5.675.079.277.127.588.14.937z"
          />
          <path
            fill="#b1eced"
            d="M15.238 26.614c-.5.858-.076 2.035.86 2.466.988.456 2.289-.04 2.61-1.036.305-.947-.396-1.967-1.352-2.223-.768-.206-1.702.08-2.118.793z"
          />
          <path
            fill="#5fbbe8"
            d="M30.805 25.125c-1.024 1.304-1.94 1.885-2.512.81a3.36 3.36 0 01-.263-.705c-.257-.962.936-8.247 2.906-6.866.51.357.827.879.997 1.483.487 1.734-.238 4.145-1.128 5.278z"
          />
          <path
            fill="#5faede"
            d="M31.063 25.363c-1.026 1.297-1.944 1.875-2.517.806.813-.488 2.28-1.913 3.648-6.057.488 1.725-.239 4.124-1.131 5.251z"
          />
          <path
            fill="#b1eced"
            d="M29.686 21.348c-.292 1.1-.9 2.947-1.129 2.906-.206-.038-.134-1.618.441-3.117.32-.835.83-1.732.985-1.687.192.056-.206 1.556-.297 1.898z"
          />
          <path
            fill="#5fbbe8"
            d="M12.015 17.708a2.62 2.62 0 01-.621-.749 2.626 2.626 0 01-.195-2.135 2.509 2.509 0 012.124-1.668c.795 2.814-1.308 4.552-1.308 4.552z"
          />
          <path
            fill="#5faede"
            d="M11.953 17.697a2.611 2.611 0 01-.599-.75 35.687 35.687 0 001.256-3.66c.188-.072.388-.12.594-.14l-1.251 4.55z"
          />
          <path
            fill="#5fbbe8"
            d="M26.18 18.908c.133 3.59-7.966 5.664-12.052 3.93-1.135-.482-1.96-1.258-2.213-2.377C10.75 15.317 13.7 10.17 17.692 9.734c1.446-.157 3.206.207 4.747 1.272 1.974 1.363 3.592 3.873 3.74 7.902z"
          />
          <path
            fill="#294f81"
            d="M23.822 16.091c.078.711-.659 1.235-1.643 1.605-1.036.391-2.345.612-3.263.703-1.315.13-3.872.18-4.877-.548-.236-.17-.385-.384-.414-.648a2.753 2.753 0 01.627-2.066 2.94 2.94 0 011.951-1.04l4.428-.482a2.935 2.935 0 012.396.83c.433.431.724 1 .795 1.646z"
          />
          <path
            fill="#33487a"
            d="M23.824 16.119c.077.699-.652 1.213-1.625 1.577-1.025.384-2.32.601-3.23.691-1.3.129-3.83.178-4.824-.536 2.565-.356 6.894-1.247 8.893-3.349.428.424.717.983.786 1.617z"
          />
          <path
            fill="#5faede"
            d="M26.187 18.915c.132 3.583-7.995 5.654-12.095 3.924 2.402.13 9.521.217 10.417-3.26.77-2.992-.997-6.68-2.074-8.548 1.981 1.359 3.604 3.863 3.752 7.884z"
          />
          <path
            fill="#b1eced"
            d="M13.773 13.817c.24.258 1.465-.474 2.26-1.218.763-.714 1.503-1.788 1.287-2.045-.193-.228-1.107.229-1.67.619-1.261.873-2.138 2.363-1.877 2.644zM12.472 19.583c.127 1 .746 1.889.951 1.798.216-.095.007-1.282-.162-1.929-.048-.185-.342-1.32-.573-1.287-.182.026-.299.77-.216 1.418z"
          />
          <path
            fill="#393760"
            d="M22.802 15.684a1.249 1.249 0 11-2.483.272 1.249 1.249 0 012.483-.272z"
          />
          <path
            fill="#46aed2"
            d="M21.371 14.076a1.614 1.614 0 00-1.203.606 1.614 1.614 0 00-.18 1.757 1.627 1.627 0 001.623.874c.43-.047.818-.26 1.089-.598.272-.338.395-.762.348-1.193a1.618 1.618 0 00-1.677-1.446zm.008.236a1.388 1.388 0 01.108 2.772 1.387 1.387 0 01-.108-2.772z"
          />
          <path
            fill="#2f4572"
            d="M22.781 14.993c-.36 1.296-1.587 1.397-2.322 1.333a1.424 1.424 0 01-.14-.48c-.084-.76.44-1.443 1.169-1.527a1.317 1.317 0 011.293.674z"
          />
          <path
            fill="#b1eced"
            d="M21.288 15.194a.375.375 0 11-.745.081.375.375 0 01.745-.081zM22.786 15.765c.075.037.028.469-.273.664-.267.173-.654.107-.672.03-.012-.056.18-.092.484-.311.32-.231.408-.409.461-.383z"
          />
          <path
            fill="#393760"
            d="M17.072 16.172a1.249 1.249 0 11-2.483.272 1.249 1.249 0 012.483-.272z"
          />
          <path
            fill="#46aed2"
            d="M15.637 14.557a1.613 1.613 0 00-1.204.606 1.612 1.612 0 00-.348 1.193 1.628 1.628 0 001.791 1.438 1.626 1.626 0 001.223-2.436 1.618 1.618 0 00-1.462-.801zm.011.236a1.384 1.384 0 011.43 1.236 1.386 1.386 0 11-1.43-1.236z"
          />
          <path
            fill="#2f4572"
            d="M17.047 15.476c-.36 1.296-1.588 1.394-2.323 1.33a1.428 1.428 0 01-.14-.48c-.083-.759.44-1.443 1.169-1.527a1.322 1.322 0 011.294.677z"
          />
          <path
            fill="#b1eced"
            d="M15.566 15.905a.375.375 0 11-.746.08.375.375 0 01.746-.08zM16.799 16.265c.075.037.028.469-.273.664-.267.173-.654.107-.671.03-.013-.056.18-.092.483-.311.321-.231.409-.409.461-.383z"
          />
          <path
            fill="#296abd"
            d="M18.737 13.966c.022.083-.53.344-1.118.464-.953.193-1.87-.014-1.868-.122 0-.05.61-.122 1.826-.264.978-.115 1.149-.122 1.16-.078z"
          />
          <path
            fill="#5fbbe8"
            d="M11.073 15.228c-.028-.018-.696-.444-1.179-1.366-.442-.844-.805-2.282-.025-4.337l.364.138c-.582 1.533-.583 2.879-.004 4.001.433.837 1.046 1.232 1.052 1.236z"
          />
          <path
            fill="#294f81"
            d="M11.298 9.33a1 1 0 11-1.993-.14 1 1 0 011.993.14z"
          />
          <path
            fill="#296abd"
            d="M9.794 9.066a.5.5 0 10.993-.11.5.5 0 00-.993.11z"
          />
          <path
            fill="#294f81"
            d="M19.227 21.406c-.635.087-1.172-.147-1.585-.488-.74-.61-1.081-1.562-.879-1.612.317-.077 1.154.331 2.017.213.993-.136 1.623-.563 2.13-.661a.94.94 0 01.066-.011c.518-.071.202 2.292-1.749 2.559z"
          />
          <path
            fill="#33487a"
            d="M19.298 21.4c-.614.086-1.133-.149-1.532-.49.813-.27 2.395-.915 3.154-2.056a.916.916 0 01.065-.01c.5-.071.197 2.292-1.687 2.556z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default AiraBotTitle;
